import {
  COMMON_QUERY_CONFIG,
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  COMMON_VIDEO_QUERY_RULES_CONFIG,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  HEALTH = 'Health',
  PHARMA = 'Pharma',
  WELLNESS = 'Wellness',
  HEALTHCARE = 'Healthcare',
  DEFAULT = 'Default',
  RELATED_OPINION = 'Related Opinion',
  VIDEO = 'Video'
}

const MAIN = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? []), ruleNewsPlus],
    or: [
      { terms: { key: 'DJEThing', value: ['health'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['health/pharma'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['health/wellness'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['health/healthcare'] } }
    ]
  }
};

const PHARMA = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['health/pharma'] } }]
  }
};

const WELLNESS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['health/wellness'] } }]
  }
};

const HEALTHCARE = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['health/healthcare'] } }]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: ['health', 'health/pharma', 'health/wellness', 'health/healthcare']
        }
      }
    ],
    or: [],
    not: []
  }
};

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'DJEThing', value: 'health' } }, { prefix: { key: 'DJEThing', value: 'health/' } }],
    not: []
  }
};

export { MAIN, SECTION_ENUM, PHARMA, WELLNESS, HEALTHCARE, RELATED_OPINION, VIDEO };
